// src/components/Reports/Summaries/UptimeSummary.js
import React from 'react';
import { Row, Col } from 'react-bootstrap';

const UptimeSummary = ({ summary }) => {
    return (
        <Row>
            <Col lg={3} md={6} className="mb-3">
                <div className="p-3 bg-light rounded text-center">
                    <h6 className="text-muted mb-2">Průměrná dostupnost</h6>
                    <div className="fs-3 fw-bold text-primary">{summary.averageUptime}%</div>
                </div>
            </Col>
            <Col lg={3} md={6} className="mb-3">
                <div className="p-3 bg-light rounded text-center">
                    <h6 className="text-muted mb-2">Celková doba výpadků</h6>
                    <div className="fs-3 fw-bold text-primary">{summary.totalDowntime}</div>
                </div>
            </Col>
            <Col lg={3} md={6} className="mb-3">
                <div className="p-3 bg-light rounded text-center">
                    <h6 className="text-muted mb-2">Počet výpadků</h6>
                    <div className="fs-3 fw-bold text-primary">{summary.downtimeCount}</div>
                </div>
            </Col>
            <Col lg={3} md={6} className="mb-3">
                <div className="p-3 bg-light rounded text-center">
                    <h6 className="text-muted mb-2">Nejdelší výpadek</h6>
                    <div className="fs-3 fw-bold text-primary">{summary.longestDowntime}</div>
                </div>
            </Col>
        </Row>
    );
};

export default UptimeSummary;